import { DataSourceProvider } from '@onereach/billing-shared';

export const DATA_SOURCE_MAP = {
  [DataSourceProvider.AZURE]: 'Azure',
  [DataSourceProvider.DRUID]: 'Druid',
};
